import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import LocalRides from '@/pages/LocalRides';
import AirportRides from '@/pages/AirportRides';
import ServiceArea from '@/pages/ServiceArea';
import RequestRide from '@/pages/RequestRide';
import Contact from '@/pages/Contact';
import { initTheme } from '@/lib/theme';

function App() {
  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/local-rides-staten-island" element={<LocalRides />} />
          <Route path="/airport-rides-staten-island" element={<AirportRides />} />
          <Route path="/staten-island-service-area" element={<ServiceArea />} />
          <Route path="/request-a-ride" element={<RequestRide />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
